import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import participantsSlice from '../reducers/participants.slice'

const persistConfig = {
  key: 'participantsSlice',
  storage,
}

export const persistedParticipantsReducer = persistReducer(persistConfig, participantsSlice)